// Karsilama mesajinin dil cozumu: locale -> site varsayilani -> ilk dolu dil -> hazir metin.
// Varsayilan kapali: panelden acilmadikca bos doner ve karsilama hic cizilmez.

function resolveWelcomeGreeting(settings, locale, fallback) {
    const s = settings || {};
    const greeting = (s.webchat || {}).welcomeGreeting || {};
    if (greeting.enabled !== true) return "";
    const content = greeting.languageContent || [];
    const pick = (code) => content.find((x) => x.languageCode === code && (x.text || "").trim());
    const siteDefault = s.language && s.language.customerClientDefault;
    const entry = pick(locale) || pick(siteDefault) || content.find((x) => (x.text || "").trim());
    if (entry) return entry.text.trim();
    // Eski tek dilli alan: panelde girisi yoktu ama API ile doldurulmus olabilir.
    const legacy = (s.autoStartChatMessage || "").trim();
    return legacy || fallback || "";
}

module.exports = { resolveWelcomeGreeting };



// WEBPACK FOOTER //
// ./src/utils/welcomeGreeting.js